// How a market is laid out. The simulation uses this to know where each
// trader stands, and the game uses it to put a stall there, so the two agree.
export const STALLS = 60; // stall spots around one market
const INNER = 8; // metres from the middle to the nearest stalls
const OUTER = 42; // and to the farthest

// Stall k of the market whose middle is (x, z): spread evenly outward like the
// seeds of a sunflower. Returns { x, z, fx, fz } where (fx, fz) points from the
// stall to the middle of the market, the side its buyers stand on.
export function stallSpot(x, z, k) {
  const a = k * 2.399963 + x * 0.013 + z * 0.007; // each market is turned its own way
  const r = INNER + (OUTER - INNER) * Math.sqrt((k + 0.5) / STALLS);
  const c = Math.cos(a);
  const s = Math.sin(a);
  return { x: x + c * r, z: z + s * r, fx: -c, fz: -s };
}
